/*
  Cart Popup 003: the two-row cart drawer (sections/cart-popup-main-003.liquid prints the markup and #cp03-config).

  Public contract, used by the product page, the sticky button, the header and the Subscribe box:
    window.cartPopup003 (also window.cartUI): open(), close(), fetchCart(), render(cart), cartCache, wrapper,
      syncInventoryState(cart), updateHeaderCartCount(count)
    event 'cart:inventory:sync' { cart, cartQtyMap, inventoryCaps }; globals _fiboliInventoryCaps, _fiboliCartItems
  Every cart change runs through one queue, so fast taps, plan changes and suggestions never overlap.
*/
(function () {
  'use strict';

  /* ---------- pure helpers (unit tested in node) ---------- */
  var MINUS = '\u2212', NBSP = '\u00a0';
  var Lib = {
    esc: function (s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    money: function (cents, format) {
      var c = Number(cents); if (!isFinite(c)) c = 0;
      var group = function (n, dec, th, sep) {
        var parts = (n / 100).toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return parts.join(sep);
      };
      return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return group(c, 0, ',', '.');
        if (k === 'amount_with_comma_separator') return group(c, 2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return group(c, 0, '.', ',');
        if (k === 'amount_with_apostrophe_separator') return group(c, 2, "'", '.');
        return group(c, 2, ',', '.');
      });
    },
    moneyShort: function (cents, format) { return Lib.money(cents, format).replace(/[.,]00(?=\D*$)/, ''); },
    pctOff: function (price, compare) { return compare > 0 && compare > price ? Math.round((1 - price / compare) * 100) : 0; },
    offText: function (pct, fr) { return MINUS + pct + (fr ? NBSP + '%' : '%'); },
    /* the plan's words on the chip and in its menu, from the one word list (snippet fiboli-kit) in the style chosen in
       the theme editor (How often words: once, every, short); '' when the length is unknown, then the plan's own name shows */
    planChip: function (days, fr, kit, style) {
      if (!kit || !kit.planPhrase) return '';
      return style === 'short' ? (kit.planShort ? kit.planShort(days, fr) : '') : kit.planPhrase(days, fr, style);
    },
    planList: function (days, fr, kit, style) { return kit && kit.planPhrase ? kit.planPhrase(days, fr, style) : ''; },
    cleanPlanName: function (name) {
      var n = String(name || '').replace(/^(deliver(ed|y)?|livrer|livraison)\s+/i, '').replace(/\s*(?:,|\s[\u2013\u00b7-])\s*[^,]*\d+[\s\u00a0]*%[^,]*$/, '').trim();
      return n ? n.charAt(0).toUpperCase() + n.slice(1) : '';
    },
    /* [[planId, price, compareAt], ...] from #cp03-config (or product.js) -> plans sorted from least to most often */
    plansFrom: function (rows, names, kit) {
      return (rows || []).map(function (r) {
        var name = (names && names[r[0]]) || '';
        return { id: Number(r[0]), price: Number(r[1]), compare: Number(r[2]), name: name, days: kit ? kit.planDays(name) : -1, pct: Lib.pctOff(Number(r[1]), Number(r[2])) };
      }).sort(function (a, b) { return (a.days < 0 ? 1e9 : a.days) - (b.days < 0 ? 1e9 : b.days); });
    },
    pickPlan: function (plans, lastId, defFreq, kit) {
      if (!plans || !plans.length) return null;
      for (var i = 0; i < plans.length; i++) if (String(plans[i].id) === String(lastId)) return plans[i];
      var j = kit ? kit.closest(plans.map(function (p) { return p.name; }), defFreq) : -1;
      return j >= 0 ? plans[j] : plans[0];
    },
    lineView: function (item, wasOn) {
      var spa = item.selling_plan_allocation || null, hasCode = item.original_line_price > item.final_line_price;
      var was = hasCode ? item.original_line_price : (wasOn && spa && spa.compare_at_price > spa.price ? spa.compare_at_price * item.quantity : 0);
      if (was && was <= item.final_line_price) was = 0;
      var vt = item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null' ? item.variant_title : '';
      return { was: was, now: item.final_line_price, planId: spa && spa.selling_plan ? spa.selling_plan.id : null, planName: spa && spa.selling_plan ? spa.selling_plan.name || '' : '', variant: vt,
        codes: (item.discounts || []).map(function (d) { return d && d.title; }).filter(Boolean) };
    },
    shipState: function (cart, c, kit) {
      /* one calculation for the cart and the Subscribe box on product pages (snippet fiboli-kit) */
      if (kit.shipState) return kit.shipState(cart, c);
      var counted = kit.cartCount(cart, c.rule), total = counted.total;
      if (counted.subOnly && total < c.min) total = c.min;
      var pct = c.min > 0 ? Math.min(100, Math.round(total / c.min * 100)) : 100;
      return { total: total, pct: pct, step: c.min > 0 ? kit.shipStep(total, c.min, c.s2, c.s3) : 4, gap: Math.max(0, c.min - total), subOnly: counted.subOnly };
    },
    /* Later subscription deliveries ship on their own. The note shows while this order is under the amount and one
       delivery (per plan) is under it too; returns how much that delivery is short, or null */
    subNoteGap: function (cart, c, total) {
      if (c.rule === 'always' || !(c.min > 0) || total >= c.min) return null;
      var groups = {}, worst = null;
      (cart.items || []).forEach(function (it) {
        var a = it && it.selling_plan_allocation; if (!a) return;
        var k = String((a.selling_plan && a.selling_plan.id) || 'plan');
        var unit = c.rule === 'before' && a.compare_at_price > a.price ? a.compare_at_price : a.price;
        groups[k] = (groups[k] || 0) + (Number(unit) || 0) * (it.quantity || 0);
      });
      Object.keys(groups).forEach(function (k) { if (groups[k] < c.min && (worst === null || groups[k] < worst)) worst = groups[k]; });
      return worst === null ? null : c.min - worst;
    },
    /* "Subscription savings" line: hidden when the only line in the cart already shows its own crossed-out price */
    savingsState: function (cart, on, wasOn) {
      var items = cart.items || [], saved = 0, crossed = 0;
      items.forEach(function (it) {
        var a = it.selling_plan_allocation; if (!a || !(a.compare_at_price > a.price)) return;
        saved += (a.compare_at_price - a.price) * it.quantity;
        if (wasOn && !(it.original_line_price > it.final_line_price)) crossed++;
      });
      return { saved: saved, show: !!(on && saved > 0 && !(items.length === 1 && crossed === 1)) };
    },
    fill: function (tpl, amount) { return String(tpl || '').split(/\{amount\}|\[amount\]/).join(amount); },
    imgUrl: function (url, w) {
      if (!url) return '';
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
      return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
    }
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = Lib; return; }
  if (window.cartPopup003 && window.cartPopup003.__v3) return;

  /* ---------- state ---------- */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KIT = window.FiboliKit;
  var cfg = null, T = {}, el = {};
  var st = {
    queue: Promise.resolve(), pending: 0, debounce: {}, optimistic: {}, busyKey: null,
    maxNote: {}, errKey: null, errTimer: 0, plans: {}, names: {}, must: {}, fetching: {}, sample: false, cacheAt: 0, open: false, gen: 0,
    savedX: 0, savedY: 0, lastFocus: null, adding: {}
  };
  var I = {
    trash: '<svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M3 5h12M7 5V3h4v2M5 5l.8 10h6.4L13 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    minus: '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M3 7h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M3 7h8M7 3v8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    truck: '<svg viewBox="0 0 24 16" aria-hidden="true" focusable="false"><path d="M1.5 2.5h12v9h-12zM13.5 5.5h4.5l3.5 3.5v2.5h-8" style="fill:var(--cp-card)" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="6" cy="13" r="1.9" style="fill:var(--cp-card)" stroke="currentColor" stroke-width="1.5"/><circle cx="17.5" cy="13" r="1.9" style="fill:var(--cp-card)" stroke="currentColor" stroke-width="1.5"/></svg>',
    truckSolid: '<svg viewBox="0 0 24 16" aria-hidden="true" focusable="false"><path d="M1.5 2.5h12v9h-12zM13.5 5.5h4.5l3.5 3.5v2.5h-8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="6" cy="13" r="1.9" fill="currentColor"/><circle cx="17.5" cy="13" r="1.9" fill="currentColor"/></svg>',
    check: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    flag: '<svg viewBox="0 0 16 18" aria-hidden="true" focusable="false"><path d="M3 17V2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M3.5 2.5h9l-2.2 3 2.2 3h-9z" style="fill:var(--cp-btn)" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    caret: '<svg class="cp03-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    tag: '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 2h5.5L14 8.5 8.5 14 2 7.5z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="5" cy="5" r="1.1" fill="currentColor"/></svg>'
  };
  var RE = '<span class="cp03-ic" aria-hidden="true"><svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" style="vertical-align:-.15em"><path d="M13.5 8a5.5 5.5 0 1 1-1.6-3.9M13 1.8v2.9h-2.9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  var OK = '<svg viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true" focusable="false" style="vertical-align:-.15em"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function url(path) { return ROOT + path; }
  function fr() { return !!(cfg && cfg.fr); }
  function money(c) { return Lib.money(c, cfg && cfg.money); }
  /* a request that hangs gives up after 15 s, so the cart queue can never stall */
  function timed(href, init) {
    if (window.AbortController) { var ctrl = new AbortController(); init.signal = ctrl.signal; setTimeout(function () { ctrl.abort(); }, 15000); }
    return fetch(href, init);
  }
  function post(path, body) { return timed(url(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' }); }
  function planOf(it) { return it && it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : null; }
  function caps() { return (window._fiboliInventoryCaps = window._fiboliInventoryCaps || {}); }
  function cssEsc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }
  function lastPlan() { try { return (JSON.parse(sessionStorage.getItem('fiboliSub:v1') || 'null') || {}).plan; } catch (e) { return null; } }
  function rememberPlan(id) { try { var o = JSON.parse(sessionStorage.getItem('fiboliSub:v1') || 'null') || {}; o.plan = String(id); sessionStorage.setItem('fiboliSub:v1', JSON.stringify(o)); } catch (e) {} }

  /* ---------- binding (again after the theme editor reloads the section) ---------- */
  function bind() {
    var w = document.getElementById('cart-popup-main-003');
    if (!w) { UI.wrapper = null; return false; }
    if (w === UI.wrapper && cfg) return true;
    var c = document.getElementById('cp03-config');
    try { cfg = JSON.parse(c ? c.textContent : '{}'); } catch (e) { cfg = {}; console.error('[CartPopup] config', e); }
    T = cfg.t || {};
    st.names = cfg.names || {};
    st.plans = {}; st.fetching = {}; st.must = cfg.must || {};
    Object.keys(cfg.plans || {}).forEach(function (v) { st.plans[v] = Lib.plansFrom(cfg.plans[v], st.names, KIT); });
    UI.wrapper = w;
    el = {
      drawer: w.querySelector('.cp03-drawer'), count: w.querySelector('[data-cp03-count]'), fs: w.querySelector('[data-cp03-fs]'),
      scroll: w.querySelector('[data-cp03-scroll]'), items: w.querySelector('[data-cp03-items]'), empty: w.querySelector('[data-cp03-empty]'),
      ups: w.querySelector('[data-cp03-ups]'), rail: w.querySelector('[data-cp03-rail]'), thumb: w.querySelector('[data-cp03-thumb]'),
      foot: w.querySelector('[data-cp03-foot]'), sum: w.querySelector('[data-cp03-sum]'),
      co: w.querySelector('[data-cp03-checkout]'), total: w.querySelector('[data-cp03-total]'), fine: w.querySelector('[data-cp03-fine]'),
      live: w.querySelector('[data-cp03-live]'), sampleNote: w.querySelector('[data-cp03-sample]')
    };
    UI.container = el.items;
    buildFs();
    wireRail();
    if (window.ResizeObserver && el.drawer) { new ResizeObserver(function () { schedFit(); updRail(); }).observe(el.drawer); }
    return true;
  }

  /* ---------- cart API ---------- */
  function fetchCart() {
    var attempt = function (n) {
      return timed(url('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function (c) { if (!c || typeof c !== 'object') throw new Error('bad cart'); if (!Array.isArray(c.items)) c.items = []; return c; })
        .catch(function (e) { if (n < 1) return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return attempt(n + 1); }); console.error('[CartPopup] fetchCart', e); return null; });
    };
    return attempt(0);
  }
  /* one cart change at a time; only the last change of a burst renders */
  function enqueue(task) {
    st.pending++; st.gen++;
    var run = st.queue.then(task).catch(function (e) { console.error('[CartPopup]', e); }).then(function (r) { st.pending--; return r; });
    st.queue = run;
    return run;
  }
  function settle(cart) {
    if (st.pending > 1) return;
    if (cart) commit(cart); else return fetchCart().then(function (c) { if (c) commit(c); else if (UI.cartCache) UI.render(UI.cartCache); });
  }
  function commit(cart) {
    UI.cartCache = cart; st.cacheAt = Date.now(); window._fiboliCartItems = cart.items;
    UI.render(cart); UI.syncInventoryState(cart); UI.updateHeaderCartCount(cart.item_count || 0);
  }
  function changeLine(key, qty) {
    return enqueue(function () {
      var want = qty;
      return post('cart/change.js', { id: key, quantity: qty }).then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (e) {
          var m = String((e && (e.description || e.message)) || '').match(/(\d+)/);
          if (r.status === 422 && m) learnCap(key, Number(m[1]));
          return null;
        });
      }).catch(function () { return null; }).then(function (cart) {
        if (cart && want > 0) {
          var it = (cart.items || []).filter(function (x) { return x.key === key; })[0];
          if (it && it.quantity < want) learnCap(key, it.quantity, it.variant_id);
        }
        /* Shopify has answered for this line: show its number, unless the shopper tapped again meanwhile */
        if (st.optimistic[key] === want && !(key in st.debounce)) delete st.optimistic[key];
        return settle(cart && Array.isArray(cart.items) ? cart : null);
      });
    });
  }
  function learnCap(key, n, variantId) {
    var it = variantId ? { variant_id: variantId } : ((UI.cartCache && UI.cartCache.items) || []).filter(function (x) { return x.key === key; })[0];
    if (it) caps()[it.variant_id] = n;
    st.maxNote[key] = n;
  }

  /* ---------- plans per variant (#cp03-config first, the product's .js as a fallback) ---------- */
  function plansFor(item) {
    var v = String(item.variant_id);
    if (st.plans[v]) return st.plans[v];
    if (!item.handle || st.fetching[item.handle]) return null;
    st.fetching[item.handle] = timed(url('products/' + encodeURIComponent(item.handle) + '.js'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (p) {
        (p.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (sp) { st.names[sp.id] = sp.name || ''; }); });
        (p.variants || []).forEach(function (x) {
          if (p.requires_selling_plan) st.must[String(x.id)] = 1;
          st.plans[String(x.id)] = Lib.plansFrom((x.selling_plan_allocations || []).map(function (a) { return [a.selling_plan_id, a.price, a.compare_at_price || x.price]; }), st.names, KIT);
        });
        if (!st.plans[v]) st.plans[v] = [];
        if (UI.cartCache && st.open) UI.render(UI.cartCache);
      })
      .catch(function () { delete st.fetching[item.handle]; });
    return null;
  }

  /* ---------- free shipping looks ---------- */
  function buildFs() {
    if (!el.fs) return;
    var s = cfg.fs || {}, look = s.look;
    if (!look || look === 'off' || !(s.min > 0)) { el.fs.hidden = true; el.fs.innerHTML = ''; return; }
    var bar = ' role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-label="' + Lib.esc(T.fsLabel) + '"';
    var marks = [s.s2, s.s3].filter(function (x) { return x > 0 && x < s.min; });
    var h = '';
    if (look === 'ring') {
      h = '<div class="cp03-ring"' + bar + '><svg class="cp03-ring__svg" viewBox="0 0 42 42" aria-hidden="true" focusable="false"><circle class="cp03-ring__bg" cx="21" cy="21" r="19"/><circle class="cp03-ring__fg" cx="21" cy="21" r="19" pathLength="100" stroke-dasharray="100" stroke-dashoffset="100"/></svg><span class="cp03-ring__ic" data-ic>' + I.truck + '</span></div><p class="cp03-msg" data-msg></p>';
    } else if (look === 'road') {
      h = '<p class="cp03-msg" data-msg></p><div class="cp03-road"' + bar + '><span class="cp03-road__tr"><i data-fill></i></span>' +
        marks.map(function (m) { return '<span class="cp03-road__dot" data-at="' + m + '" style="left:' + (m / s.min * 100).toFixed(2) + '%"></span>'; }).join('') +
        '<span class="cp03-road__truck" data-truck>' + I.truck + '</span><span class="cp03-road__flag">' + I.flag + '</span></div>';
    } else if (look === 'steps') {
      h = '<p class="cp03-msg" data-msg></p><div class="cp03-steps"' + bar + '><span class="cp03-steps__ln"><i data-fill></i></span>' +
        marks.concat([s.min]).map(function (m, i, a) { var last = i === a.length - 1; return '<span class="cp03-steps__st' + (last ? ' is-last' : '') + '" data-at="' + m + '" style="--p:' + (m / s.min).toFixed(4) + '"><span>' + (last ? I.truckSolid : I.check) + '</span>' + Lib.esc(Lib.moneyShort(m, cfg.money)) + '</span>'; }).join('') + '</div>';
    } else {
      h = '<p class="cp03-msg" data-msg></p><div class="cp03-bar"' + bar + '><i data-fill></i></div>';
    }
    el.fs.className = 'cp03-fs cp03-fs--' + look;
    el.fs.innerHTML = h;
  }
  function renderFs(cart, ship) {
    if (!el.fs || !el.fs.firstChild || !ship) return;
    var s = cfg.fs;
    el.fs.hidden = !(cart.items && cart.items.length);
    el.fs.classList.toggle('is-free', ship.step === 4);
    var pb = el.fs.querySelector('[role="progressbar"]'); if (pb) pb.setAttribute('aria-valuenow', String(ship.pct));
    var msg = el.fs.querySelector('[data-msg]');
    if (msg) {
      var tpl = ship.step === 4 ? (ship.subOnly ? T.subShip : s.msgs[3]) : s.msgs[ship.step - 1];
      var parts = String(tpl || '').split(/\{amount\}|\[amount\]/);
      msg.textContent = '';
      parts.forEach(function (p, i) {
        if (i) { var b = document.createElement('b'); b.textContent = money(ship.gap); msg.appendChild(b); }
        msg.appendChild(document.createTextNode(p));
      });
    }
    var fill = el.fs.querySelector('[data-fill]'); if (fill) fill.style.width = ship.pct + '%';
    var ring = el.fs.querySelector('.cp03-ring__fg'); if (ring) ring.style.strokeDashoffset = String(100 - ship.pct);
    var ic = el.fs.querySelector('[data-ic]'); if (ic) { var want = ship.step === 4 ? 'check' : 'truck'; if (ic.dataset.k !== want) { ic.dataset.k = want; ic.innerHTML = want === 'check' ? I.check : I.truck; } }
    var truck = el.fs.querySelector('[data-truck]'); if (truck) truck.style.left = 'clamp(12px, ' + ship.pct + '%, calc(100% - 12px))';
    el.fs.querySelectorAll('[data-at]').forEach(function (d) { d.classList.toggle('is-on', ship.total >= Number(d.dataset.at)); });
  }

  /* ---------- items ---------- */
  function subControl(item, v, plans) {
    var look = cfg.sub, key = Lib.esc(item.key), cur = v.planId, off = '';
    var curPlan = null;
    if (plans) for (var i = 0; i < plans.length; i++) if (plans[i].id === cur) curPlan = plans[i];
    var label = function (p) { return Lib.planChip(p.days, fr(), KIT, cfg.words) || Lib.cleanPlanName(p.name); };
    /* Theme settings > Show Subscribe & save off: no invitation on one-time lines; a line already on a plan keeps it,
       and its menu offers only that plan and One-time */
    if (cfg.subsOn === false) {
      if (!cur) return '';
      if (curPlan) plans = [curPlan];
    }
    if (cur && (!plans || !curPlan)) {
      /* subscribed, plans not known (yet): show the plan, no menu */
      var d = KIT ? KIT.planDays(v.planName) : -1;
      return '<span class="cp03-chip is-on is-static">' + RE + '<b>' + Lib.esc(Lib.planChip(d, fr(), KIT, cfg.words) || Lib.cleanPlanName(v.planName)) + '</b></span>';
    }
    if (!plans || !plans.length || look === 'off') {
      return cur && curPlan ? '<span class="cp03-chip is-on is-static">' + RE + '<b>' + Lib.esc(label(curPlan)) + '</b></span>' : '';
    }
    var pick = curPlan || Lib.pickPlan(plans, lastPlan(), cfg.defFreq, KIT);
    if (pick && pick.pct > 0) off = Lib.offText(pick.pct, fr());
    var busy = st.busyKey === item.key ? ' is-busy' : '';
    /* the chip that opens "How often?": a button for the Clean list (Theme settings > Dropdown menus), otherwise a
       chip with the browser's own select laid over it */
    var chip = function (cls, inner, withOnce) {
      /* the spoken name starts with the words on the chip (what a voice-control user says), then what it is for */
      if (window.FiboliMenu) return '<button type="button" class="cp03-chip ' + cls + busy + '" data-act="plan-menu" data-k="' + key + '" data-once="' + (withOnce ? 1 : 0) + '" aria-haspopup="listbox" aria-expanded="false">' + inner + I.caret + '<span class="cp03-sr"> · ' + Lib.esc(T.howOften + ' · ' + item.product_title) + '</span></button>';
      return '<span class="cp03-chip ' + cls + busy + '">' + inner + I.caret + '<select class="cp03-sel" data-act="plan" data-k="' + key + '" aria-label="' + Lib.esc(T.howOften + ' · ' + item.product_title) + '">' +
        planRows(plans, withOnce).map(function (r) { return '<option value="' + r.value + '"' + (String(r.value) === String(cur || '') ? ' selected' : '') + '>' + Lib.esc(r.label + (r.tag ? ' · ' + r.tag : '')) + '</option>'; }).join('') + '</select></span>';
    };
    if (cur && st.must[String(item.variant_id)]) return chip('is-on', RE + '<b>' + Lib.esc(label(curPlan)) + '</b>' + (look === 'switch' || !off ? '' : '<span class="cp03-tag">' + off + '</span>'), false);
    if (look === 'switch') {
      var sw = '<button type="button" class="cp03-sw' + busy + '" role="switch" aria-checked="' + !!cur + '" data-act="' + (cur ? 'sub-off' : 'sub-on') + '" data-k="' + key + '" data-plan="' + (pick ? pick.id : '') + '" aria-label="' + Lib.esc(T.subscribe + (off ? ' ' + off : '') + ' · ' + item.product_title) + '"><i aria-hidden="true"></i>' +
        (cur ? '' : '<span class="cp03-lg">' + Lib.esc(T.subscribe) + '</span>' + (off ? '<b class="cp03-off">' + off + '</b>' : '')) + '</button>';
      return '<span class="cp03-subw">' + sw + (cur ? chip('is-on', RE + '<b>' + Lib.esc(label(curPlan)) + '</b>', false) : '') + '</span>';
    }
    if (cur) return chip('is-on', RE + '<b>' + Lib.esc(label(curPlan)) + '</b>' + (off ? '<span class="cp03-tag">' + off + '</span>' : ''), true);
    return chip('is-inv', RE + '<span class="cp03-lg">' + Lib.esc(T.subscribe) + '</span>' + (off ? (look === 'outline' ? '<span class="cp03-tag">' + off + '</span>' : '<b class="cp03-off">' + off + '</b>') : ''), true);
  }
  /* the rows of "How often?": every plan with its saving, then One-time (when the line can be bought without a plan) */
  function planRows(plans, withOnce) {
    var rows = plans.map(function (p) { return { value: String(p.id), label: Lib.planList(p.days, fr(), KIT, cfg.words) || Lib.cleanPlanName(p.name), tag: p.pct > 0 ? Lib.offText(p.pct, fr()) : '' }; });
    if (withOnce) rows.push({ value: '', label: T.oneTime, tag: '', apart: true });
    return rows;
  }
  function openPlanMenu(b) {
    /* in the theme editor an empty cart shows sample lines: the menu opens on them too, to preview its look */
    var key = b.dataset.k, it = st.sample ? (cfg.sample.items || []).filter(function (x) { return x.key === key; })[0] : lineOf(key);
    if (!it) return;
    var plans = st.sample ? (st.plans[String(it.variant_id)] || []) : plansFor(it);
    var planNow = Lib.lineView(it, cfg.subWas).planId;
    if (cfg.subsOn === false) plans = (plans || []).filter(function (p) { return p.id === planNow; });
    if (!plans || !plans.length) return;
    var tags = window.FiboliMenu.tags;
    window.FiboliMenu.open(b, {
      label: T.howOften, value: planNow ? String(planNow) : '', host: el.drawer, className: 'cp03-menu',
      options: planRows(plans, b.dataset.once === '1').map(function (r) { if (!tags) r.tag = ''; return r; }),
      onPick: function (v, a) {
        if (st.sample) { UI.render(UI.cartCache || { items: [] }); return; }
        /* the chip may have been redrawn while the list was open: its line key is the current one */
        setPlan((a && a.dataset.k) || key, v ? Number(v) : null);
      }
    });
  }
  function cap(item) {
    var live = UI._getLiveInventory(item.variant_id);
    if (live !== null && live !== Infinity) return live;
    var c = caps()[item.variant_id];
    return c === undefined ? Infinity : c;
  }
  function row(item, opt) {
    var v = Lib.lineView(item, cfg.subWas), key = Lib.esc(item.key), title = item.product_title || item.title || '';
    var q = st.optimistic[item.key] !== undefined ? st.optimistic[item.key] : item.quantity;
    var limit = cap(item), atMax = q >= limit;
    if (q !== item.quantity && item.quantity > 0) { v.now = Math.round(v.now * q / item.quantity); v.was = Math.round(v.was * q / item.quantity); }
    var plans = opt.sample ? (st.plans[String(item.variant_id)] || []) : plansFor(item);
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    var href = Lib.esc(item.url || '#');
    var sr = function (t) { return '<span class="cp03-sr">' + Lib.esc(t) + '</span>'; };
    var note = st.maxNote[item.key] !== undefined && q >= st.maxNote[item.key] ? '<span class="cp03-max">' + Lib.esc(String(T.only).replace('[n]', st.maxNote[item.key])) + '</span>' : '';
    var err = st.errKey === item.key ? '<span class="cp03-err" role="alert">' + Lib.esc(T.subErr) + '</span>' : '';
    var sub = subControl(item, v, plans);
    var meta = (v.variant ? '<span class="cp03-var">' + Lib.esc(v.variant) + '</span>' : '') +
      v.codes.map(function (c) { return '<span class="cp03-code">' + I.tag + Lib.esc(c) + '</span>'; }).join('') + note + err;
    return '<div class="cp03-it' + (st.busyKey === item.key ? ' is-busy' : '') + '" data-key="' + key + '" data-variant="' + item.variant_id + '">' +
      '<a class="cp03-pic" href="' + href + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + Lib.esc(Lib.imgUrl(img, 160)) + '" alt="" width="80" height="80" decoding="async">' : '') + '</a>' +
      '<div class="cp03-top"><a class="cp03-name" href="' + href + '">' + Lib.esc(title) + '</a><span class="cp03-price">' +
        (v.was ? '<s class="cp03-was">' + sr(T.regular) + Lib.esc(money(v.was)) + '</s>' : '') + '<span class="cp03-now">' + (v.was ? sr(T.now) : '') + Lib.esc(money(v.now)) + '</span></span></div>' +
      '<div class="cp03-bot">' + (meta ? '<div class="cp03-meta">' + meta + '</div>' : '') +
        '<span class="cp03-step"><button type="button" data-act="dec" data-k="' + key + '" aria-label="' + Lib.esc((q <= 1 ? T.remove : T.less) + ' · ' + title) + '">' + (q <= 1 ? I.trash : I.minus) + '</button>' +
        '<output aria-label="' + Lib.esc(T.qty) + '">' + q + '</output>' +
        '<button type="button" data-act="inc" data-k="' + key + '" aria-label="' + Lib.esc(T.more + ' · ' + title) + '"' + (atMax ? ' disabled title="' + Lib.esc(T.maxQty) + '"' : '') + '>' + I.plus + '</button></span>' +
        (sub ? '<div class="cp03-subc">' + sub + '</div>' : '') + '</div></div>';
  }

  /* When the subscription control does not fit beside the quantity, it gives way step by step, whatever the font or text:
     1 the small extras (↻ on the invitation, the tag on a subscribed line), 2 it takes the full width under the size
     (quantity moves up), 3 smaller text without ▾, 4 the word itself */
  var fitRaf = 0;
  function schedFit() { if (fitRaf) return; fitRaf = requestAnimationFrame(function () { fitRaf = 0; fit(); }); }
  function fit() {
    if (!el.items || !st.open) return;
    el.items.querySelectorAll('.cp03-bot').forEach(function (b) {
      b.removeAttribute('data-fit');
      var box = b.querySelector('.cp03-subc'); if (!box) return;
      var over = function () {
        var right = box.getBoundingClientRect().right + 0.5, o = false;
        box.querySelectorAll('.cp03-chip, .cp03-sw, .cp03-subw').forEach(function (c) { if (c.getBoundingClientRect().right > right) o = true; });
        return o;
      };
      for (var lvl = 1; lvl <= 4 && over(); lvl++) b.setAttribute('data-fit', String(lvl));
    });
    if (el.co && el.co.clientWidth) {
      /* the button's words against the room inside its padding (the text is centred, so scrollWidth would only see
         half of what spills over) */
      var co = el.co;
      var need = function () {
        var w = 0, k = 0;
        Array.prototype.forEach.call(co.children, function (c) { var s = getComputedStyle(c); if (s.display === 'none' || s.position === 'absolute') return; w += c.getBoundingClientRect().width; k++; });
        return w + (parseFloat(getComputedStyle(co).columnGap) || 0) * Math.max(0, k - 1);
      };
      var room = function () { var s = getComputedStyle(co); return co.clientWidth - (parseFloat(s.paddingLeft) || 0) - (parseFloat(s.paddingRight) || 0); };
      var over = function () { return need() > room() + 0.5; };
      co.removeAttribute('data-fit'); co.style.fontSize = '';
      for (var l = 1; l <= 2 && over(); l++) co.setAttribute('data-fit', String(l));
      /* still too long (a big text size from the theme editor, a long French total): shrink just enough, not below 12px */
      for (var n = 0; n < 3 && over(); n++) {
        var fs = parseFloat(getComputedStyle(co).fontSize);
        co.style.fontSize = Math.max(12, Math.floor(fs * room() / need() * 10) / 10) + 'px';
        if (fs <= 12) break;
      }
    }
  }

  /* ---------- the suggestions row ---------- */
  function wireRail() {
    if (!el.ups || !el.rail || el.rail.dataset.wired) return;
    el.rail.dataset.wired = '1';
    el.rail.addEventListener('scroll', function () { requestAnimationFrame(updRail); }, { passive: true });
  }
  function updRail() {
    if (!el.rail || !el.ups || el.ups.hidden) return;
    var sw = el.rail.scrollWidth, cw = el.rail.clientWidth, sl = Math.abs(el.rail.scrollLeft);
    el.ups.classList.toggle('is-fit', sw <= cw + 2);
    if (el.thumb) { el.thumb.style.width = Math.min(100, cw / sw * 100).toFixed(1) + '%'; el.thumb.style.left = (sl / sw * 100).toFixed(1) + '%'; }
    var prev = el.ups.querySelector('[data-act="rail-prev"]'), next = el.ups.querySelector('[data-act="rail-next"]');
    if (prev) prev.disabled = sl < 4;
    if (next) next.disabled = sl + cw >= sw - 4;
  }
  function railStep(dir) {
    var card = el.rail && el.rail.querySelector('.cp03-card:not([hidden])'); if (!card) return;
    var gap = parseFloat(getComputedStyle(el.rail).columnGap) || 10;
    var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    el.rail.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: smooth ? 'smooth' : 'auto' });
  }
  function renderRail(cart) {
    if (!el.ups) return;
    var inCart = {}; (cart.items || []).forEach(function (it) { inCart[it.product_id] = 1; });
    var shown = 0;
    el.ups.querySelectorAll('.cp03-card').forEach(function (c) {
      var hide = cfg.up.hideInCart && inCart[c.dataset.product] && !st.adding[c.dataset.variant];
      c.hidden = !!hide; if (!hide) shown++;
    });
    el.ups.hidden = shown === 0;
    requestAnimationFrame(updRail);
  }
  function loadRailImages() {
    if (!el.ups) return;
    el.ups.querySelectorAll('img[data-src]').forEach(function (img) { img.src = img.dataset.src; if (img.dataset.srcset) img.srcset = img.dataset.srcset; img.removeAttribute('data-src'); });
  }
  function addFromRail(btn) {
    var id = Number(btn.dataset.variant); if (!id || btn.disabled || st.adding[id]) return;
    var inCart = ((UI.cartCache && UI.cartCache.items) || []).reduce(function (n, it) { return it.variant_id === id ? n + it.quantity : n; }, 0);
    var c = caps()[id]; if (c !== undefined && inCart >= c) { soldOut(id); return; }
    st.adding[id] = 1; btn.disabled = true; label(btn, T.adding); btn.classList.add('is-adding');
    enqueue(function () {
      return post('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function (r) {
        if (r.ok) return r.json().then(function () { return 'ok'; });
        return r.json().catch(function () { return {}; }).then(function (e) {
          var msg = String((e && (e.description || e.message)) || '');
          if (!/selling plan|plan de vente|abonnement|subscription/i.test(msg) && /sold out|stock|inventory|only|all \d|épuisé|que \d|tous les \d/i.test(msg)) {
            var m = msg.match(/(?:only\s+(?:add\s+)?|all\s+|que\s+|tous les\s+)(\d+)/i);
            caps()[id] = m ? Math.min(Number(m[1]), inCart) : inCart;
            return 'sold';
          }
          return 'err';
        });
      }).catch(function () { return 'err'; }).then(function (res) {
        btn.classList.remove('is-adding');
        if (res === 'sold') { soldOut(id); delete st.adding[id]; }
        else if (res === 'ok') { label(btn, T.added, OK); btn.classList.add('is-done'); }
        else { label(btn, T.tryAgain); btn.classList.add('is-err'); }
        var done = function () { delete st.adding[id]; if (!btn.classList.contains('is-sold')) { label(btn, '+ ' + T.add); btn.disabled = false; btn.classList.remove('is-done', 'is-err'); } if (UI.cartCache) renderRail(UI.cartCache); };
        setTimeout(done, res === 'ok' ? 1400 : 2200);
        return settle(null);
      });
    });
  }
  function label(btn, text, icon) { var l = btn.querySelector('[data-lbl]') || btn; if (icon) l.innerHTML = icon + ' ' + Lib.esc(text); else l.textContent = text; }
  function soldOut(id) {
    document.querySelectorAll('#cart-popup-main-003 .cp03-card__add[data-variant="' + id + '"]').forEach(function (b) {
      b.disabled = true; b.classList.add('is-sold'); label(b, T.soldOut); var c = b.closest('.cp03-card'); if (c) c.classList.add('is-sold');
    });
  }

  /* ---------- the drawer ---------- */
  var UI = {
    __v3: true, wrapper: null, container: null, cartCache: null,
    fetchCart: fetchCart,
    /* true while a cart change is waiting or on its way to Shopify */
    isBusy: function () { return st.pending > 0 || Object.keys(st.debounce).length > 0 || !!st.busyKey; },
    init: function () {
      if (!bind()) return;
      var self = this;
      if (/^\/?(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname.replace(ROOT, '/').replace(/^\//, ''))) {
        var ref = null; try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) { ref = null; }
        var back = ref && ref.origin === location.origin && !/\/(cart|checkouts?)(\/|$)/.test(ref.pathname) ? ref.pathname + ref.search : ROOT;
        location.replace(back + (back.indexOf('?') >= 0 ? '&' : '?') + 'open_cart=1');
        return;
      }
      fetchCart().then(function (c) {
        if (!c) { self.cartCache = self.cartCache || { items: [], item_count: 0, total_price: 0, __fake: true }; return; }
        if (!self.cartCache || self.cartCache.__fake) { self.cartCache = c; st.cacheAt = Date.now(); }
        self.updateHeaderCartCount(c.item_count || 0);
        self.syncInventoryState(c);
        if (st.open) self.render(c);
      });
      var params = new URLSearchParams(location.search);
      if (params.has('open_cart')) {
        params.delete('open_cart');
        history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params.toString() : '') + location.hash);
        setTimeout(function () { self.open(); }, 300);
      }
      if (window.Shopify && window.Shopify.designMode) {
        var keep = false; try { keep = sessionStorage.getItem('cp03-editor-open') === '1'; } catch (e) {}
        if (keep || cfg.editorOpen) setTimeout(function () { self.open(); }, 300);
      }
    },
    open: function () {
      if (!bind()) return;
      var self = this;
      if (st.open) { this.refresh(); return; }
      st.open = true;
      /* the stylesheet loads without blocking the page; if it has not switched on yet, switch it on now */
      var css = document.querySelector('link[href*="cart-popup-003"][media="print"]'); if (css) css.media = 'all';
      st.lastFocus = document.activeElement;
      st.savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
      st.savedX = window.pageXOffset || document.documentElement.scrollLeft || 0;
      lockPage(true);
      var own = this.wrapper.closest('.shopify-section') || this.wrapper.parentElement;
      document.querySelectorAll('.shopify-section, .shopify-section-group, header, [data-section-type]').forEach(function (n) {
        if (n === own || n.contains(own) || own.contains(n)) return;
        if (!n.hasAttribute('inert')) { n.setAttribute('inert', ''); n.dataset.cartBgInerted = '1'; }
      });
      loadRailImages();
      if (this.cartCache && Date.now() - st.cacheAt < 1500) this.render(this.cartCache); else this.skeleton();
      this.wrapper.classList.add('active');
      this.wrapper.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
      if (el.drawer) el.drawer.focus({ preventScroll: true });
      this.refresh();
      setTimeout(schedFit, 450);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedFit);
    },
    refresh: function () {
      var self = this, gen = st.gen;
      return fetchCart().then(function (cart) {
        if (!cart) { if (self.cartCache && self.cartCache.items && !self.cartCache.__fake) self.render(self.cartCache); else self.renderError(T.loadError); return; }
        window._fiboliCartItems = cart.items;
        return self._capCartToLiveInventory(cart).then(function (capped) {
          /* a cart change made meanwhile draws the newer cart itself */
          if (capped || (gen === st.gen && !st.pending)) commit(capped || cart);
          if (typeof window.fiboliRefreshVariantInventory === 'function') window.fiboliRefreshVariantInventory();
        });
      });
    },
    close: function () {
      if (!this.wrapper || !st.open) return;
      if (window.FiboliMenu) window.FiboliMenu.close(false);
      st.open = false;
      this.wrapper.classList.remove('active');
      this.wrapper.setAttribute('aria-hidden', 'true');
      lockPage(false);
      window.scrollTo(st.savedX, st.savedY);
      document.removeEventListener('keydown', onKey);
      if (st.lastFocus && typeof st.lastFocus.focus === 'function' && document.contains(st.lastFocus)) st.lastFocus.focus({ preventScroll: true });
    },
    skeleton: function () {
      if (!el.items) return;
      el.items.setAttribute('aria-busy', 'true');
      el.items.innerHTML = '<div class="cp03-skel" aria-hidden="true"><i></i><i></i></div><p class="cp03-sr">' + Lib.esc(T.loading) + '</p>';
      if (el.empty) el.empty.hidden = true;
    },
    renderError: function (message) {
      if (!el.items) return;
      el.items.innerHTML = '<div class="cp03-error" role="alert"><p>' + Lib.esc(message) + '</p><button type="button" class="cp03-btn" data-act="retry">' + Lib.esc(T.retry) + '</button></div>';
    },
    render: function (cart) {
      if (!bind()) return;
      if (!cart || typeof cart !== 'object') { this.renderError(T.loadError); return; }
      if (!Array.isArray(cart.items)) cart.items = [];
      var real = cart;
      st.sample = !cart.items.length && !!(window.Shopify && window.Shopify.designMode && cfg.sample && cfg.sample.items && cfg.sample.items.length);
      if (st.sample) cart = cfg.sample;
      var count = cart.item_count || 0, empty = !cart.items.length;
      if (el.count) { el.count.textContent = count; el.count.hidden = !count; }
      var ship = cfg.fs && cfg.fs.min > 0 ? Lib.shipState(cart, cfg.fs, KIT) : null;
      renderFs(cart, ship);
      /* keep keyboard focus on the same control after the list is rebuilt */
      var f = document.activeElement, fr0 = f && f.closest ? f.closest('.cp03-it') : null;
      var sig = f && el.items && el.items.contains(f) && f.dataset ? [f.dataset.act, f.dataset.k, fr0 ? fr0.dataset.variant : ''] : null;
      if (el.items) {
        el.items.setAttribute('aria-busy', 'false');
        var keys = {}; cart.items.forEach(function (it) { keys[it.key] = 1; });
        Object.keys(st.maxNote).forEach(function (k) { if (!keys[k]) delete st.maxNote[k]; });
        /* an open "How often?" list follows its line to the redrawn chip (plans arriving, stock updates) */
        var menuAt = window.FiboliMenu && window.FiboliMenu.anchorIn(el.items), menuRow = menuAt && menuAt.closest('.cp03-it');
        el.items.innerHTML = cart.items.map(function (it) { return row(it, { sample: st.sample }); }).join('');
        el.items.toggleAttribute('data-sample', st.sample);
        if (menuAt) window.FiboliMenu.rebind(el.items.querySelector('[data-act="plan-menu"][data-k="' + cssEsc(menuAt.dataset.k || '') + '"]') ||
          el.items.querySelector('.cp03-it[data-variant="' + cssEsc(menuRow ? menuRow.dataset.variant : '') + '"] [data-act="plan-menu"]'));
      }
      if (el.sampleNote) el.sampleNote.hidden = !st.sample;
      if (el.empty) el.empty.hidden = !empty;
      if (el.scroll) el.scroll.classList.toggle('is-empty', empty);
      renderRail(real);
      var sav = Lib.savingsState(cart, cfg.savingsRow, cfg.subWas);
      if (el.sum) { el.sum.hidden = !sav.show; if (sav.show) el.sum.lastElementChild.textContent = MINUS + money(sav.saved); }
      var est = (cart.total_price || 0) + cart.items.reduce(function (n, it) { var q = st.optimistic[it.key]; return q !== undefined && it.quantity > 0 ? n + Math.round((q - it.quantity) * it.final_line_price / it.quantity) : n; }, 0);
      if (el.total) el.total.textContent = money(est);
      if (el.co) { el.co.disabled = empty; el.co.hidden = empty; el.co.classList.remove('is-loading'); }
      if (el.fine) {
        var hasSub = cart.items.some(function (it) { return !!it.selling_plan_allocation; });
        var text = hasSub && cfg.terms ? T.terms : T.note;
        var gap = hasSub && cfg.subNote && ship ? Lib.subNoteGap(cart, cfg.fs, ship.total) : null;
        if (gap !== null && cfg.subNote) text += ' ' + Lib.fill(cfg.subNote.replace('[min]', Lib.moneyShort(cfg.fs.min, cfg.money)), money(gap));
        el.fine.textContent = empty ? '' : text;
        el.fine.hidden = empty || !text;
      }
      if (el.foot) el.foot.classList.toggle('is-empty', empty);
      if (sig && sig[0]) {
        var back = el.items.querySelector('[data-act="' + sig[0] + '"][data-k="' + cssEsc(sig[1] || '') + '"]');
        if (!back && sig[2]) {
          var same = el.items.querySelector('.cp03-it[data-variant="' + cssEsc(sig[2]) + '"]');
          back = same && (same.querySelector('[data-act="' + sig[0] + '"]') || same.querySelector('.cp03-subc [data-act]'));
        }
        if (back && !back.disabled) back.focus({ preventScroll: true });
        else if (!el.items.contains(document.activeElement)) el.drawer.focus({ preventScroll: true }); /* the line is gone (removed) */
      }
      schedFit();
      if (document.fonts && document.fonts.status === 'loading') document.fonts.ready.then(schedFit);
    },
    syncInventoryState: function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var map = {};
      cart.items.forEach(function (it) { map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity; });
      var self = this;
      document.querySelectorAll('#cart-popup-main-003 .cp03-card__add').forEach(function (btn) {
        var id = parseInt(btn.dataset.variant, 10); if (!id || st.adding[id]) return;
        var inCart = map[id] || 0, c = caps()[id], live = self._getLiveInventory(id);
        var limit = c !== undefined ? c : null;
        if (live !== null && live !== Infinity) limit = limit !== null ? Math.min(limit, live) : live;
        else if (limit === null && btn.dataset.tracked === '1' && btn.dataset.policy === 'deny' && !isNaN(parseInt(btn.dataset.qty, 10))) limit = parseInt(btn.dataset.qty, 10);
        if (limit !== null && inCart >= limit) soldOut(id);
        else if (btn.classList.contains('is-sold') && btn.dataset.soldAtLoad !== '1') {
          if (c !== undefined) delete caps()[id];
          btn.disabled = false; btn.classList.remove('is-sold'); label(btn, '+ ' + T.add);
          var card = btn.closest('.cp03-card'); if (card) card.classList.remove('is-sold');
        }
      });
      document.dispatchEvent(new CustomEvent('cart:inventory:sync', { detail: { cart: cart, cartQtyMap: map, inventoryCaps: Object.assign({}, caps()) } }));
    },
    _getLiveInventory: function (variantId) {
      if (!Array.isArray(window.variants)) return null;
      var v = window.variants.filter(function (x) { return x.id === variantId; })[0];
      if (!v) return null;
      if (!v.inventory_management || v.inventory_policy === 'continue') return Infinity;
      return typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0;
    },
    _capCartToLiveInventory: function (cart) {
      var self = this, ups = [];
      if (!cart || !Array.isArray(cart.items) || !Array.isArray(window.variants)) return Promise.resolve(null);
      cart.items.forEach(function (it) { var live = self._getLiveInventory(it.variant_id); if (live !== null && live !== Infinity && it.quantity > live) ups.push({ id: it.key, quantity: Math.max(0, live) }); });
      if (!ups.length) return Promise.resolve(null);
      return ups.reduce(function (p, u) { return p.then(function () { return post('cart/change.js', u).catch(function () {}); }); }, Promise.resolve()).then(fetchCart);
    },
    updateHeaderCartCount: function (count) {
      var html = count > 0 ? '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' ' + Lib.esc(T.items) + '</span>' : '';
      var proxy = document.getElementById('cart-icon-bubble');
      var b = proxy && proxy.querySelector('.cart-count-bubble'); if (b) b.innerHTML = html;
      document.querySelectorAll('[data-fiboli-cart-bubble]').forEach(function (n) { n.innerHTML = html; });
      if (typeof window.updateCartCount === 'function') window.updateCartCount(count);
    }
  };

  /* ---------- actions ---------- */
  function lineOf(key) { return ((UI.cartCache && UI.cartCache.items) || []).filter(function (x) { return x.key === key; })[0]; }
  function step(key, delta) {
    var it = lineOf(key); if (!it || st.busyKey === key) return;
    var cur = st.optimistic[key] !== undefined ? st.optimistic[key] : it.quantity, q = cur + delta;
    if (q < 1) { removeLine(key); return; }
    if (delta > 0 && q > cap(it)) { st.maxNote[key] = cap(it); UI.render(UI.cartCache); return; }
    st.optimistic[key] = q;
    UI.render(UI.cartCache);
    clearTimeout(st.debounce[key]);
    st.debounce[key] = setTimeout(function () { flush(key); }, cfg.qtyDebounce || 300);
    if (el.live) el.live.textContent = T.qty + ' ' + q;
  }
  function flush(key) {
    if (!(key in st.debounce)) return null;
    clearTimeout(st.debounce[key]); delete st.debounce[key];
    var q = st.optimistic[key];
    return changeLine(key, q);
  }
  function flushAll() { Object.keys(st.debounce).forEach(flush); }
  function removeLine(key) {
    var it = lineOf(key); if (!it) return;
    clearTimeout(st.debounce[key]); delete st.debounce[key]; delete st.optimistic[key];
    var n = el.items && el.items.querySelector('.cp03-it[data-key="' + cssEsc(key) + '"]'); if (n) n.classList.add('is-gone');
    /* said to screen readers only; nothing is shown */
    if (el.live) el.live.textContent = String(T.removed).replace('[title]', it.product_title || it.title || '');
    if (n && n.contains(document.activeElement)) el.drawer.focus({ preventScroll: true });
    changeLine(key, 0);
  }
  /* switch plan, start or stop a subscription. Shopify names the line by position for this ("line"), null = one-time */
  function setPlan(key, planId) {
    var it0 = lineOf(key);
    /* one plan change at a time: a second one is refused and its menu shows the real plan again */
    if (st.busyKey || !it0) { if (UI.cartCache) UI.render(UI.cartCache); return; }
    if ((planOf(it0) || null) === (planId || null)) return;
    var pending = flush(key);
    st.busyKey = key; st.errKey = null; UI.render(UI.cartCache);
    var variant = it0.variant_id, target = planId || null;
    var done = function (ok, cart) {
      st.busyKey = null;
      if (!ok) { st.errKey = cart ? (((cart.items || []).filter(function (x) { return x.variant_id === variant; })[0]) || {}).key || key : key; clearTimeout(st.errTimer); st.errTimer = setTimeout(function () { st.errKey = null; if (UI.cartCache) UI.render(UI.cartCache); }, 6000); }
      if (ok && target) rememberPlan(target);
    };
    (pending || Promise.resolve()).then(function () {
      return enqueue(function () {
        return fetchCart().then(function (now) {
          var items = (now && now.items) || [], i = -1;
          for (var n = 0; n < items.length; n++) if (items[n].key === key) i = n;
          if (i < 0) for (var m = 0; m < items.length; m++) if (items[m].variant_id === variant && planOf(items[m]) === planOf(it0)) i = m;
          if (i < 0) { done(false, now); return settle(now); }
          var it = items[i];
          return post('cart/change.js', { line: i + 1, quantity: it.quantity, selling_plan: target }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
            .then(function (cart) { return cart && Array.isArray(cart.items) ? cart : fetchCart(); })
            .then(function (cart) {
              var ok = !!(cart && cart.items.some(function (x) { return x.variant_id === variant && (planOf(x) || null) === target; }));
              done(ok, cart);
              if (cart) commit(cart); else if (UI.cartCache) UI.render(UI.cartCache);
            });
        });
      });
    }).then(function () { if (st.busyKey === key) { st.busyKey = null; if (UI.cartCache) UI.render(UI.cartCache); } });
  }
  function checkout(btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    flushAll();
    var started = Date.now();
    /* the shop's language path (/fr/checkout) opens Shopify checkout in that language */
    var go = function () { try { window.top.location.href = url('checkout'); } catch (e) { location.href = url('checkout'); } };
    var wait = function () { if (!UI.isBusy() || Date.now() - started > 3000) go(); else setTimeout(wait, 40); };
    wait();
    setTimeout(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }, 10000);
  }

  function lockPage(on) {
    var b = document.body.style;
    if (on) { b.position = 'fixed'; b.top = -st.savedY + 'px'; b.left = -st.savedX + 'px'; b.width = '100%'; b.overflowY = 'scroll'; return; }
    b.position = ''; b.top = ''; b.left = ''; b.width = ''; b.overflowY = '';
    document.querySelectorAll('[data-cart-bg-inerted]').forEach(function (n) { n.removeAttribute('inert'); delete n.dataset.cartBgInerted; });
  }
  function onKey(e) {
    if (!st.open) return;
    if (e.key === 'Escape') { UI.close(); return; }
    if (e.key !== 'Tab' || !el.drawer) return;
    var list = Array.prototype.filter.call(el.drawer.querySelectorAll('a[href], button, select, input, [tabindex]:not([tabindex="-1"])'), function (n) {
      return !n.disabled && n.getAttribute('tabindex') !== '-1' && !n.closest('[hidden]') && n.getClientRects().length;
    });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (!el.drawer.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var root = t.closest('#cart-popup-main-003'); if (!root) return;
    if (t.closest('[data-cp03-close]') || (t.closest('[data-cp03-overlay]') && cfg && cfg.closeOnOverlay)) { e.preventDefault(); UI.close(); return; }
    var b = t.closest('[data-act]'); if (!b || b.tagName === 'SELECT') return;
    var act = b.dataset.act, key = b.dataset.k;
    if (act === 'plan-menu') { e.preventDefault(); openPlanMenu(b); return; }
    if (st.sample && b.closest('[data-cp03-items]')) { e.preventDefault(); return; }
    if (act === 'inc' || act === 'dec') { e.preventDefault(); step(key, act === 'inc' ? 1 : -1); }
    else if (act === 'sub-on') { e.preventDefault(); setPlan(key, Number(b.dataset.plan) || null); }
    else if (act === 'sub-off') { e.preventDefault(); setPlan(key, null); }
    else if (act === 'add') { e.preventDefault(); addFromRail(b); }
    else if (act === 'rail-prev' || act === 'rail-next') { e.preventDefault(); railStep(act === 'rail-next' ? 1 : -1); }
    else if (act === 'checkout') { e.preventDefault(); checkout(b); }
    else if (act === 'retry') { e.preventDefault(); UI.refresh(); }
  });
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest && e.target.closest('#cart-popup-main-003 select[data-act="plan"]'); if (!s) return;
    if (st.sample) { UI.render(UI.cartCache || { items: [] }); return; }
    setPlan(s.dataset.k, s.value ? Number(s.value) : null);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (el.co) { el.co.classList.remove('is-loading'); el.co.removeAttribute('aria-busy'); }
    if (st.open) UI.refresh(); else fetchCart().then(function (c) { if (c) { UI.cartCache = c; UI.updateHeaderCartCount(c.item_count || 0); } });
  });
  /* the shopper heads for the cart (cart icon, Add to cart, sticky button): fetch the suggestion photos now, so they are
     ready when the popup opens; pages where nobody opens the cart download nothing extra */
  document.addEventListener('pointerdown', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('a, button') : null; if (!b || el.ups === undefined && !bind()) return;
    if (b.id === 'FiboliAddToCartBtn' || b.id === 'cart-icon-bubble' || b.hasAttribute('data-sticky-atc-btn') || b.querySelector('[data-fiboli-cart-bubble], .cart-count-bubble') || /\/cart(\?|$)/.test(b.getAttribute('href') || '')) loadRailImages();
  }, { passive: true, capture: true });
  /* a font (e.g. the bold face of a label) can arrive after the labels were measured: measure again */
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { if (st.open) schedFit(); });
  if (window.Shopify && window.Shopify.designMode) {
    var mine = function (e) { return !!(e.target && e.target.querySelector && e.target.querySelector('#cart-popup-main-003')); };
    document.addEventListener('shopify:section:select', function (e) { if (!mine(e)) return; try { sessionStorage.setItem('cp03-editor-open', '1'); } catch (x) {} UI.open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (!mine(e)) return; try { sessionStorage.removeItem('cp03-editor-open'); } catch (x) {} UI.close(); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!mine(e)) return;
      var wasOpen = st.open; st.open = false; UI.wrapper = null; cfg = null;
      if (wasOpen) { lockPage(false); window.scrollTo(st.savedX, st.savedY); document.removeEventListener('keydown', onKey); }
      if (bind() && wasOpen) UI.open();
    });
  }

  window.cartPopup003 = UI;
  window.cartUI = UI;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { UI.init(); });
  else UI.init();
})();
